// Both employee endpoints exist: one contains only surveyors, the other all
// staff. Prefer the full live directory so pure draftsmen are never omitted.
export function draftsmanChoices(employees, allEmployees = [], currentId = null) {
  const source = Array.isArray(allEmployees) && allEmployees.length ? allEmployees : employees;
  const seen = new Set();
  return (Array.isArray(source) ? source : []).filter(employee => {
    const raw = employee?.position;
    const positions = Array.isArray(raw) ? raw : typeof raw === 'string' ? raw.split(',').map(value => value.trim()) : [];
    const id = Number(employee?.id);
    if (!Number.isInteger(id) || id <= 0 || seen.has(id) || employee.is_block || !positions.includes('draftsman')) return false;
    seen.add(id);
    return currentId == null || id !== Number(currentId);
  });
}
